/**
 * A day (a date cell without a time) is stored as UTC midnight of its
 * calendar day, for every writer and reader. The interface works with the
 * local `Date` of that calendar day, so pickers and formatters show the same
 * day in every zone.
 */
export function localDateOfDay(value: number): Date {
  const day = new Date(value);
  return new Date(day.getUTCFullYear(), day.getUTCMonth(), day.getUTCDate());
}

/** The stored day of the calendar day a local `Date` falls on. */
export function dayOfLocalDate(date: Date): number {
  return Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
}
